<template>
  <!-- PAGE : PREMIUM-->
  <div class="page text-center mb-7">
    <div class="text-center mb-5">
      <div class="btn-group btn-group-toggle">
        <label class="btn btn-round btn-outline-secondary" :class="{ active: planPeriod == 'yearly' }">
          <input v-model="planPeriod" type="radio" value="yearly" autocomplete="off">
          {{ printLang("Pricing.Annual") }} <br>
          <span class="text-success">{{ printLang("Pricing.Offer") }}</span>
        </label>
        <label :class="{ active: planPeriod == 'monthly' }" class="btn btn-round btn-outline-secondary d-flex align-items-center">
          <input v-model="planPeriod" type="radio" value="monthly" autocomplete="off">
          {{ printLang("Pricing.Monthly") }}
        </label>
      </div>
    </div>

    <!--REGULAR OFFERS-->
    <div class="col-md-12">
      <div class="row" style="line-height: 1.3em">
        <!-- TEAM -->
        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4">
          <div class="pricing-1 h-100 d-flex flex-column">
            <form class="mb-4" @submit.prevent="sendDataCheckout($event.target)">
              <div class="p-4 text-white bg-team">
                <div class="h3 text-uppercase mb-0">{{ printLang("Pricing.Team") }}</div>
                {{ printLang("Pricing.TeamSubtitle") }}
              </div>
              <div class="price mt-5">
                <div class="price-container">
                  <h4 class="mt-3 mx-3 text-dark">
                    {{ planPeriod == 'yearly' ? '12€' : '14,40€' }}
                    <span style="font-size: initial;">HT / utilisateur</span>
                  </h4>
                </div>
              </div>
              <p>{{ planPeriod == 'yearly' ? 'Facturé annuellement' : 'Sans engagement de durée' }}</p>
              <div class="mb-2 p-3" style="line-height: 46px;">
                <select v-model="quantityUsersTeam" name="users" class="form-control form-control-lg">
                  <option v-for="nbUsers in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50, 75, 100]" :key="nbUsers" :value="nbUsers">
                    {{ `${nbUsers} ${nbUsers == 1 ? printLang("Pricing.User") : printLang("Pricing.Users") }` }}
                  </option>
                </select>
              </div>
              <input type="hidden" name="plan" :value="planPeriod == 'yearly' ? 'team12m' : 'team'">
              <input v-if="couponIsAvailable" type="hidden" name="coupon" :value="coupon">
              <input type="submit" class="btn btn-primary btn-cta w-200" style="align-self: center" value="Choisir">
            </form>
            <div v-if="couponIsAvailable" class="m-2 mt-6" style="align-self: center;">
              <form class="form-inline" style="font-size: smaller;" @submit.prevent="$emit('set-coupon', couponInput); couponInput = ''">
                Code promo : <input v-model="couponInput" type="text" class="mx-2 form-control input-sm" style="width: 90px;" required>
                <input class="btn btn-outline-primary btn-sm" type="submit" value="Activer">
                <div v-if="hasValidCoupon" class="text-success" style="font-size: initial;"><b>Activé : {{ coupon }}</b></div>
                <div v-else-if="coupon" class="text-danger">
                  <template v-if="coupon == 'BLACKFRIDAY' && planPeriod !== 'yearly'">Code réservé aux abonnements annuels</template>
                  <template v-else>Code promo invalide</template>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- BUSINESS -->
        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4" style="position: relative; top: -8px">
          <div class="pricing-1 popular d-flex flex-column" style="height: calc(100% + 16px)">
            <form class="mb-4" @submit.prevent="sendDataCheckout($event.target)">
              <div class="p-4 text-white bg-business">
                <div class="h3 text-uppercase mb-0">{{ printLang("Pricing.Business") }}</div>
                {{ printLang("Pricing.BusinessSubtitle") }}
                <div style="margin-bottom: 8px"></div>
              </div>
              <div class="price mt-5">
                <div class="price-container">
                  <h4 class="mt-3 mx-3 text-dark">
                    {{ planPeriod == 'yearly' ? '22€' : '26,40€' }}
                    <span style="font-size: initial;">HT / utilisateur</span>
                  </h4>
                </div>
              </div>
              <p>{{ planPeriod == 'yearly' ? 'Facturé annuellement' : 'Sans engagement de durée' }}</p>
              <div class="mb-2 p-3" style="line-height: 46px;">
                <select v-model="quantityUsersBusiness" name="users" class="form-control form-control-lg">
                  <option v-for="nbUsers in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50, 75, 100]" :key="nbUsers" :value="nbUsers">
                    {{ `${nbUsers} ${nbUsers == 1 ? printLang("Pricing.User") : printLang("Pricing.Users") }` }}
                  </option>
                </select>
              </div>
              <input type="hidden" name="plan" :value="planPeriod == 'yearly' ? 'business12m' : 'business'">
              <input v-if="couponIsAvailable" type="hidden" name="coupon" :value="coupon">
              <input type="submit" class="btn btn-success btn-cta w-200" style="align-self: center" value="Choisir">
            </form>
            <div v-if="couponIsAvailable" class="m-2 mt-6" style="align-self: center;">
              <form class="form-inline" style="font-size: smaller;" @submit.prevent="$emit('set-coupon', couponInputBusiness); couponInputBusiness = ''">
                Code promo : <input v-model="couponInputBusiness" type="text" class="mx-2 form-control input-sm" style="width: 90px;" required>
                <input class="btn btn-outline-success btn-sm" type="submit" value="Activer">
                <div v-if="hasValidCoupon" class="text-success" style="font-size: initial;"><b>Activé : {{ coupon }}</b></div>
                <div v-else-if="coupon" class="text-danger">
                  <template v-if="coupon == 'BLACKFRIDAY' && planPeriod !== 'yearly'">Code réservé aux abonnements annuels</template>
                  <template v-else>Code promo invalide</template>
                </div>
              </form>
            </div>
            <div style="margin-bottom: 8px"></div>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4">
          <div class="pricing-1 h-100 d-flex flex-column">
            <div class="p-4 text-white bg-enterprise">
              <div class="h3 text-white text-uppercase mb-0">{{ printLang("Pricing.Enterprise") }}</div>
              {{ printLang("Pricing.EnterpriseSubtitle") }}
            </div>
            <div class="pt-5 h-100" style="background: rgba(216, 149, 30, .15)">
              <div class="price">
                <div class="price-container text-dark">
                  <h6>Devis personnalisé</h6>
                </div>
              </div>
              <div class="p-3">
                <div class="text-center mt-2">
                  <!-- CONTACT FORM-->
                  <form role="form" class="mx-3" @submit.prevent="callMeBack">
                    <input type="hidden" name="name" value="From myaccount premium page.">
                    <input type="hidden" name="email" value="unknown@bubbleplan.net">
                    <input type="hidden" name="subject" value="Call me back !">
                    <input type="text" name="message" placeholder="Téléphone" class="form-control form-control-lg" required>
                    <button class="mt-3 btn btn-warning btn-cta" type="submit">Être rappelé</button>
                    <div id="contactMsg" class="text-dark" style="display:none; margin-bottom:10px"></div>
                  </form>
                </div>
                <hr class="my-5 w-200" style="border-top: 1px solid #ff9d1b">
                <div class="mb-2 w-100">
                  <a href="mailto:contact@bubbleplan.net" target="_blank" class="btn btn-round btn-outline-warning">Nous contacter par e-mail</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { printLang } from '../lang';

  // Lang
  window.jstexts = window.jstexts || {};
  Object.assign(window.jstexts, {
    MissingField: printLang('Contact.Validation.MissingField'),
    InvalidEmail: printLang('Contact.Validation.InvalidEmail'),
    MessageSent: printLang('Contact.Validation.MessageSent'),
    Error: printLang('Contact.Validation.Error'),
  });

  export default {
    props: {
      coupon: { type: String, default: '' },
    },
    data() {
      return {
        printLang,
        planPeriod: 'yearly',
        quantityUsersTeam: 10,
        quantityUsersBusiness: 10,
        couponIsAvailable: false, // no coupon available at the moment
        couponInput: '',
        couponInputBusiness: '',
      };
    },
    computed: {
      hasValidCoupon() {
        return this.coupon && ['BLACKFRIDAY'].includes(this.coupon) && this.planPeriod === 'yearly';
      },
    },
    methods: {
      sendDataCheckout(target) {
        const thisform = $(target);
        window.location = `${printLang('Url')}?${thisform.serialize()}#checkout`;
      },
      callMeBack(event) {
        window.submitContactForm(event.target);
      },
    },
  };
</script>
